import { action } from 'typesafe-actions';

import { CoreActionsEnum } from '../enums/CoreActionsEnum';
import { NoticeTypesEnum } from '../enums/NoticeTypesEnum';

export const coreSetLoading = (value: boolean) => action(CoreActionsEnum.CORE_SET_LOADING, { value });
export const coreShowNotice = (notice: string, noticeType: NoticeTypesEnum = NoticeTypesEnum.SUCCESS) =>
  action(CoreActionsEnum.CORE_SHOW_NOTICE, {
    noticeType,
    notice,
  });
export const coreHideNotices = () => action(CoreActionsEnum.CORE_HIDE_NOTICES);
export const coreChangeView = (screenSize: string) => action(CoreActionsEnum.CORE_CHANGE_VIEW, { screenSize });
export const coreSetHeaderHeight = (height: number) => action(CoreActionsEnum.CORE_SET_HEADER_HEIGHT, { height });
export const coreGetLoginPage = () => action(CoreActionsEnum.CORE_GET_LOGIN_PAGE);
export const coreSetLoginPage = (loginPageUrl: string) => action(CoreActionsEnum.CORE_SET_LOGIN_PAGE, { loginPageUrl });
